export const HEADER_HEIGHT = 80;
export const TABS_HEIGHT = 36;
export const DRAWER_WIDTH = 260;
export const FINDINGS_PANEL_WIDTH = 400;
